export enum FormStatus {
    ENABLED = 'Active',
    PRIVATE = 'Private',
    DISABLED = 'Disabled',
}
